export const round = (number, decimals) => {
    const _m = Math.pow(10, decimals)
    return Math.round(number * _m) / _m
}